import React from 'react'
import styled from 'styled-components'
import { Row, Col, Button, Modal, message } from 'antd'
import { copyToClipboard } from './../../../services/appServices'

const Contrainer = styled.div`
    .title {
        font-weight: bold;
    }
    .code-wrapper {
        width: 100%;
        background-color: #eee;
        padding: 15px;
        border-radius: 3px;
        font-family: 'Courier New', monospace;
    }
`

const ShortCodeModal = ({
    T,
    isOpen,
    existingShortcode = '',
    generatedShortcode = '',
    onClose
}) => {
    function onCopy(code) {
        copyToClipboard(code)
        message.success(T('COPIED'))
    }

    return (
        <Modal
            title={'Shortcode'}
            visible={isOpen}
            footer={
                <Row justify="space-between">
                    <Col>
                        <Button
                            key="submit"
                            type="primary"
                            onClick={() => onClose()}>
                            {T('CLOSE')}
                        </Button>
                    </Col>
                </Row>
            }
            onCancel={() => onClose()}>
            <Contrainer>
                {existingShortcode && (
                    <div style={{ marginBottom: 20 }}>
                        <Row
                            justify="space-between"
                            style={{ marginBottom: 3 }}>
                            <div className="title">Linked Shortcode</div>
                            <Button
                                size="small"
                                onClick={() => onCopy(existingShortcode)}>
                                {T('COPY')}
                            </Button>
                        </Row>
                        <div className="code-wrapper">{existingShortcode}</div>
                    </div>
                )}
                <Row justify="space-between" style={{ marginBottom: 3 }}>
                    <div className="title">Unlinked Shortcode</div>
                    <Button
                        size="small"
                        onClick={() => onCopy(generatedShortcode)}>
                        {T('COPY')}
                    </Button>
                </Row>
                <div className="code-wrapper">{generatedShortcode}</div>
            </Contrainer>
        </Modal>
    )
}

export default ShortCodeModal
